import { render, staticRenderFns } from "./mb-multiselect.vue?vue&type=template&id=141ae217&scoped=true&"
import script from "./mb-multiselect.vue?vue&type=script&lang=ts&"
export * from "./mb-multiselect.vue?vue&type=script&lang=ts&"
import style0 from "./mb-multiselect.vue?vue&type=style&index=0&lang=css&"
import style1 from "./mb-multiselect.vue?vue&type=style&index=1&id=141ae217&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141ae217",
  null
  
)

export default component.exports